/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Trip_Load_RangeInputs */

const en_exp_trip_load_range = /** @type {(inputs: Exp_Trip_Load_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under 300: an easy trip or a couple of sessions. 300-700: a solid active weekend. 700-1500: a demanding training block or week-long trip. 1500+: a big multi-week adventure with serious total strain.`)
};

const de_exp_trip_load_range = /** @type {(inputs: Exp_Trip_Load_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter 300: eine lockere Tour oder ein paar Einheiten. 300–700: ein solides aktives Wochenende. 700–1500: ein forderndes Trainingsblock- oder Wochentrip. 1500+: ein großes, mehrwöchiges Abenteuer mit ernsthafter Gesamtbelastung.`)
};

/**
* | output |
* | --- |
* | "Under 300: an easy trip or a couple of sessions. 300-700: a solid active weekend. 700-1500: a demanding training block or week-long trip. 1500+: a big multi-..." |
*
* @param {Exp_Trip_Load_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_trip_load_range = /** @type {((inputs?: Exp_Trip_Load_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Trip_Load_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_trip_load_range(inputs)
	return de_exp_trip_load_range(inputs)
});